<template>
  <v-card
    style="border: solid 4px white !important"
    class="rounded-lg px-2 py-6 elevation-0"
    :class="tipoToClass[tipo]"
    outlined
    :data-aos="!$vuetify.theme.dark ? 'fade-right' : ''"
    data-aos-easing="ease"
    data-aos-duration="500"
    data-aos-once="true"
    @click="showText = !showText"
  >
    <v-card-text
      class="box-icon text"
      :class="{ 'text-center': !$vuetify.breakpoint.smAndUp }"
    >
      <v-row align="center" justify="center">
        <v-col cols="12" lg="auto" class="d-flex justify-center align-center flex-column pl-8">
          <lord-icon
            :src="`https://cdn.lordicon.com/${tipoIcon}.json`"
            trigger="loop"
            delay="1300"
            :colors="$vuetify.theme.dark ? 'primary:#000' : 'primary:#fff'"
            style="width: 65px; height: 65px"
          >
          </lord-icon>

          <h5 class="font-weight-bold white--text text-uppercase mt-3">{{ tipoTitle }} {{numero && numero}}</h5>
        </v-col>

        <v-col
          cols="12"
          lg="10"
          class="white--text"
          v-if="showText"
        >
          <slot></slot>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
const tipoToIconAndTitle = {
  objetivos_gerais: {
    icon: "zncllhmn",
    title: "Objetivos Gerais",
  },
  voce_sabia: {
    icon: "nocvdjmh",
    title: "Você Sabia?",
  },
  curiosidade: {
    icon: "jnzhohhs",
    title: "Curiosidade",
  },
  atencao: {
    icon: "vacmyjrh",
    title: "Atenção!",
  },
  video_aula: {
    icon: "hmkhncjw",
    title: "Vídeoaula",
  },
  recapitulando: {
    icon: "yqzmiobz",
    title: "Recapitulando",
  },
  atividade: {
    icon: "yqzmiobz",
    title: "Pit stop do saber",
  },
};

export default {
  props: {
    tipo: {
      type: String,
      required: true,
    },
    numero: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      hoverIcon: false,
      showText: false,
    };
  },

  computed: {
    tipoToClass() {
      return {
        objetivos_gerais: "objetivos_gerais",
        voce_sabia: "voce_sabia",
        curiosidade: "voce_sabia",
        atencao: "atencao",
        recapitulando: "recapitulando",
        video_aula: "video_aula",
        atividade: "atividade",
      };
    },

    tipoTitle() {
      return tipoToIconAndTitle[this.tipo]?.title;
    },

    tipoIcon() {
      return tipoToIconAndTitle[this.tipo]?.icon;
    },
  },
};
</script>

<style scoped>
.box-icon {
  font-size: 1rem;
}
</style>